const theme = {
  flexboxgrid: {
    gridSize: 16,
    gutterWidth: 1.3,
    outerMargin: 0,
    container: {
      sm: 38,
      md: 49,
      lg: 56
    },
    breakpoints: {
      xs: 0,
      sm: 44,
      md: 55,
      lg: 62
    }
  }
}

export default theme
